import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import footerRing from "../Assets/he-chrome/footer-ring.svg";
import footerMark from "../Assets/he-chrome/footer-mark.svg";
import facebook from "../Assets/he-chrome/facebook.svg";
import instagram from "../Assets/he-chrome/instagram.svg";
import youtube from "../Assets/he-chrome/youtube.svg";
import googlePlay from "../Assets/he-chrome/google-play.png";
import "./Footer.css";

// Site footer, laid out like the footer in src/Components/He-Website-Source:
// brand column then three link columns; on phones the brand takes a full row.
const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="he-footer site-footer">
      <div className="he-footer-grid">
        <div className="he-footer-brand">
          <Link to="/main" className="he-footer-logo" aria-label="XianHe">
            <img src={footerRing} alt="" />
            <img className="he-footer-logo-inner" src={footerMark} alt="" />
          </Link>
          <div className="he-footer-social">
            <img src={facebook} alt="Facebook" />
            <a
              href="https://www.instagram.com/xianhefairylotus/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram} alt="Instagram" />
            </a>
            <img src={youtube} alt="YouTube" />
          </div>
          <img className="he-footer-google" src={googlePlay} alt="Get it on Google Play" />
        </div>

        <div className="he-footer-links">
          <h3>{t("footer.about")}</h3>
          <Link to="/about">{t("footer.aboutUs")}</Link>
          <Link to="/newsroom">{t("footer.newsroom")}</Link>
          <Link to="/blank">{t("footer.newsletter")}</Link>
          <Link to="/contact">{t("footer.contactUs")}</Link>
        </div>

        <div className="he-footer-links">
          <h3>{t("footer.discover")}</h3>
          <Link to="/shop">{t("footer.ourShop")}</Link>
          <Link to="/courses">{t("footer.ourCourses")}</Link>
          <Link to="/pricing">{t("footer.planPricing")}</Link>
          <Link to="/faqs">{t("footer.helpSupport")}</Link>
        </div>

        <div className="he-footer-links">
          <h3>{t("footer.termsPolicies")}</h3>
          <Link to="/returnpolicy">{t("footer.returnsRefunds")}</Link>
          <Link to="/terms-conditions">{t("footer.termsConditions")}</Link>
          <Link to="/deliveryinfo">{t("footer.deliveryInformation")}</Link>
          <Link to="/privacyinfo">{t("footer.privacyInformation")}</Link>
        </div>
      </div>
      <p className="he-footer-copy">©2024 XIANHE PTE LTD. ALL RIGHTS RESERVED.</p>
    </footer>
  );
};

export default Footer;
